module.exports = __webpack_public_path__ + "static/img/saimenInstallForWin_pic8.3d6f0f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForWin/saimenInstallForWin_pic8.png
// module id = 591
// module chunks = 1